<template>
  <cv-content id="main-content" style="max-width: 1300px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal"
            style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-tabs :container="false" aria-label="navigation tab label">
      <cv-tab id="tab-1" label="Dati Principali">
        <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
          <cv-row>
            <cv-column :sm="4" :md="4" :lg="12">
              <cv-text-input label="Descrizione"
                             value="FIAT"></cv-text-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Targa"
                             value="AB 123 CD"></cv-text-input>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="2" :md="2" :lg="4">
              <data-valida etichetta="Data di Acquisto"
                           v-model="modello.dta_acquisto"
                           messaggio_non_valido="Data di Acquisto non valida" />
            </cv-column>
            <cv-column :sm="2" :md="2" :lg="4">
              <cv-text-input label="Costo di Acquisto" value="€ 50.000" />
            </cv-column>
            <cv-column :sm="2" :md="2" :lg="4">
              <cv-text-input label="Rivalutazione in %" value="5" />
            </cv-column>
            <cv-column :sm="2" :md="2" :lg="4">
              <cv-text-input label="Durata Stimata in Ore" value="3200" />
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="2" :md="2" :lg="6">
              <cv-text-input label="Valore Attuale" value="0" readonly />
            </cv-column>
            <cv-column :sm="2" :md="2" :lg="6">
              <cv-text-input label="Ore di esercizio complessive"
                             value="0" readonly />
            </cv-column>
            <cv-column :sm="2" :md="2" :lg="4">
              <cv-text-input label="Quota oraria d'ammortamento"
                             value="0" readonly />
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
      <cv-tab id="tab-2" label="Spese">
        <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
          <cv-row>
            <cv-data-table :columns="colonne"
                           :data="righe"
                           title="Analisi delle spese" />
          </cv-row>
        </cv-grid>
      </cv-tab>
    </cv-tabs>

    <hr/>
    <Bottoniera testo_nuovo="Nuova Macchina"
                testo_salva="Salva Macchina"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";

export default {
  name: "Macchine",
  components: { Bottoniera },
  data: function() {
    return {
      modello: {
        dta_acquisto: "10/04/2015"
      },
      colonne: [
        "Anno",
        "Spese di Gestione",
        "Ore di Esercizio",
        "Spese Orarie",
        "Costo di Esercizio"
      ],
      righe: [
        [
          "2020",
          "€ 500,00",
          "800",
          "€ 35,00",
          "€ 50,00"
        ]
      ]
    }
  }
}
</script>

<style scoped>

</style>